import { Link } from "react-router-dom";
import { Home as HomeIcon, Compass } from "lucide-react";
import { LOGO } from "@/lib/site";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({ title: "Page not found — Orrbbit", description: "The page you're looking for can't be found." });
  return (
    <div data-testid="not-found-page" className="flex min-h-[70vh] items-center justify-center bg-lightbg">
      <div className="container-x text-center">
        <img src={LOGO} alt="Orrbbit" className="mx-auto h-9 w-auto" />
        <p className="mt-8 font-heading text-7xl font-bold text-teal">404</p>
        <h1 className="mt-2 font-heading text-2xl font-semibold text-navy">We can't find that page</h1>
        <p className="mx-auto mt-3 max-w-md text-bodygrey">The page may have moved or no longer exists. Let's get you back on track.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-teal px-6 py-3 font-semibold text-white transition-transform hover:scale-105">
            <HomeIcon size={18} /> Back home
          </Link>
          <Link to="/policies" className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-6 py-3 font-semibold text-navy hover:border-teal hover:text-teal">
            <Compass size={18} /> Browse policies
          </Link>
        </div>
      </div>
    </div>
  );
}

